<!--导入客户、供应商页面-->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-right">
                <div class="search-name">{{ cType == '0' ? '客户' : '供应商' }}数据上传的Excel模板</div>
                <el-button type="text" class="search-btn" @click="downFile()">点击下载</el-button>
                <el-upload
                    :action="url"
                    :headers="headerObj"
                    :on-error="uploadErr"
                    accept=".xls,.xlsx"
                    :show-file-list="false"
                    :before-upload="beforeUpload"
                    :on-success="uploadSuccess"
                    v-loading.fullscreen.lock="loading"
                >
                    <el-button size="small" icon="fa fa-file-excel-o" class="search-btn btn-primary"> 选择文件</el-button>
                </el-upload>
                <el-button size="small" icon="el-icon-upload" class="search-btn btn-primary" @click="handleUpload">保存数据</el-button>
                <div class="explain">（* 导入的数据会判断是否跟已有的{{ cType == '0' ? '客户' : '供应商' }}一致的手机号，如果一致则不写入数据）</div>
            </div>
        </div>
        <div class="search-ctn" style="min-height: 30px; padding-top: 0; margin-top: -10px">
            <div class="search-ctn-right">
                <div class="search-name" style="margin-bottom: 5px">
                    <el-tooltip effect="dark" placement="bottom">
                        <div slot="content">
                            {{
                                cType == '0'
                                    ? '当再次导入相同客户时，依据所选的更新条件更新客户信息，若没有选中更新条件则不会更新客户。'
                                    : '当再次导入相同供应商时，依据所选的更新条件更新供应商信息，若没有选中更新条件则不会更新供应商。'
                            }}
                        </div>
                        <span>
                            <i class="el-icon-warning-outline"></i>
                        </span> </el-tooltip
                    >更新条件
                </div>
                <el-checkbox-group v-model="selectedLimit" size="small">
                    <el-checkbox v-for="item in limitList" :label="item" :key="item">{{ item }}</el-checkbox>
                </el-checkbox-group>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" border :data="tableData" height="670" style="width: 100%">
                <el-table-column label="标签" show-overflow-tooltip min-width="80px" prop="Tags"></el-table-column>
                <el-table-column label="名称" show-overflow-tooltip min-width="100px" prop="Name"></el-table-column>
                <el-table-column label="手机号" show-overflow-tooltip min-width="80px" prop="PhoneNum"></el-table-column>
                <el-table-column v-if="cType == 1" label="简称" show-overflow-tooltip min-width="80px" prop="Abbr"></el-table-column>
                <el-table-column label="QQ" show-overflow-tooltip width="80px" prop="QQ"></el-table-column>
                <el-table-column label="微信" show-overflow-tooltip width="80px" prop="Wechat"></el-table-column>
                <el-table-column label="主营车型" show-overflow-tooltip min-width="150px" prop="MainVehicle"></el-table-column>
                <el-table-column label="主营配件" show-overflow-tooltip min-width="150px" prop="MainPartName"></el-table-column>
                <el-table-column label="国家" show-overflow-tooltip width="100px" prop="Country"></el-table-column>
                <el-table-column label="省市区" show-overflow-tooltip width="150px" prop="Province_City_Zone"></el-table-column>
                <el-table-column label="详细地址" show-overflow-tooltip min-width="150px" prop="Address"></el-table-column>
                <el-table-column label="备注" show-overflow-tooltip min-width="80px" prop="Remark"></el-table-column>
                <el-table-column v-if="cType == 0" label="支付方式" show-overflow-tooltip min-width="80px" prop="PayTypeName"></el-table-column>
                <el-table-column v-if="cType == 0" label="物流公司" show-overflow-tooltip min-width="80px" prop="LogisticName"></el-table-column>
                <el-table-column v-if="cType == 0" label="挂账额度" show-overflow-tooltip min-width="80px" prop="MaxCreditMoney"></el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import mixin from '@/mixins/mixin';
import breadcrumb from '@/components/common/breadcrumb';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            pageTitle: '导入Excel',
            loading: false,
            tableData: [],
            url: '/api/UploadFile/UploadEntpCustDataExcel',
            headerObj: {
                'access-key': userMsg.Token,
                reqApp: 'yqgPC'
            },
            cType: '0', //0 是普通客户；1 是供应商
            selectedLimit: [],
            limitList: ['标签', '名称'],
            recordId: ''
        };
    },
    mounted() {
        this.cType = this.$route.query.cType;
        if (this.cType == '0') this.limitList = ['标签', '名称', '支付方式', '物流公司', '省市区', '详细地址', '挂账额度'];
        else this.limitList = ['标签', '名称', '简称', '主营车型', '主营配件'];

        this.url = `${this.url}?cType=${this.cType}`;
    },
    methods: {
        downFile() {
            let a = document.createElement('a');
            // 这里的请求方式为get，如果需要认证，接口上需要带上token
            if (this.cType == '0') {
                a.href = `/download/客户上传模板.xlsx`;
            } else {
                a.href = `/download/供应商上传模板.xlsx`;
            }

            a.target = '_blank';
            a.click();
        },
        uploadSuccess(res) {
            if (res.errcode == 0) {
                this.tableData = res.data;
            } else {
                this.$util.errorMsg(res.errmsg);
            }
            this.loading = false;
        },
        uploadErr(error) {
            this.loading = false;
            const result = JSON.parse(error.message);
            this.$util.errorMsg(result.message);
        },
        beforeUpload(file) {
            this.loading = true;
            this.tableData = [];
        },
        handleUpload() {
            let that = this;
            if (!that.tableData || that.tableData.length == 0) {
                that.$util.warningMsg('请选择文件');
                return;
            }
            let updateField = that.selectedLimit.join(',');

            let desc = '';
            if (that.cType == '0') desc = '上传客户数据：' + that.tableData.length;
            else desc = '上传供应商数据：' + that.tableData.length;
            that.uploadStartRecords(desc);

            that.$util
                .axiosPost({
                    url: '/api/EntpCustomers/ImportEntpCust',
                    data: {
                        CType: that.cType,
                        CustList: that.tableData,
                        UpdateField: updateField
                    }
                })
                .then(res => {
                    if (res.errcode == 0) {
                        let msg = '';
                        if (that.cType == '0') msg = `新增客户数${res.data.addCount}，编辑客户数${res.data.editCount}，跳过客户数${res.data.jumpCount}`;
                        else msg = `新增供应商数${res.data.addCount}，编辑供应商数${res.data.editCount}，跳过供应商数${res.data.jumpCount}`;
                        that.$alert(msg, '保存成功', { confirmButtonText: '确定' });

                        that.tableData = [];

                        that.uploadEndRecords(msg);
                    }
                })
                .catch(() => {});
        },
        uploadStartRecords(desc) {
            let that = this;
            let type = 2;
            if (that.cType == '0') type = 1;
            let params = { Type: type, OpDesc: desc };
            that.$util.uploadStartRecords(params).then(res => {
                if (res.data) that.recordId = res.data;
            });
        },
        uploadEndRecords(desc) {
            let that = this;
            if (that.recordId) {
                let params = { RecordId: that.recordId, OpDesc: desc };
                that.$util.uploadEndRecords(params);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.search-btn {
    margin-left: 0;
    margin-right: 20px;
}
.explain {
    flex-shrink: 0;
    margin: 0 10px 10px;
    height: 32px;
    line-height: 32px;
    color: #ef7a82;
}
.el-icon-warning-outline {
    color: orange;
    margin-right: 5px;
}
</style>
